module.exports = __webpack_public_path__ + "img/add_desktop_step3.460cf95c.jpeg";